<template>
  <div>
    <el-dialog
      title="分配资源"
      width="90%"
      :visible="visible"
      @close="cancel(false)"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <span v-if="nodeId==0"
            style="display:inline-block;margin-bottom: 15px;font-size: 16px;font-weight: bold;color: red;">当前实例未绑定业务ID</span>
      <span v-else style="display:inline-block; margin-bottom: 15px;font-size: 16px;font-weight: bold">当前业务ID为：<span
        style="font-weight: normal;color:red">{{ nodeId }}</span></span>
      <!--      <el-button @click="" v-show="nodeId==0" type="text" style="margin-bottom: 20px;margin-left:20px; font-size: 16px">点此绑定业务ID</el-button>-->
      <span style="display: inline-block; margin-bottom: 15px" v-show="nodeId==0">
        <el-dropdown @command="bindNodeId" v-if="listOperations.some(operation => operation.name.includes('nodeId'))">
          <el-button @click="nodeClick" type="primary" size="mini" style="margin-left: 10px;margin-right: 10px">
            {{ nodeName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown" style="height: 120px;overflow-y: scroll">
            <el-dropdown-item v-show="remove" command="a">解除绑定</el-dropdown-item>
            <el-dropdown-item command="b">新增业务ID</el-dropdown-item>
            <el-dropdown-item :command="item.nodeId" v-for="(item, index) in instanceIdList" :key="index">
            <div v-if="item.lazyInstanceId" :title="'已绑定实例ID:'+item.lazyInstanceId"><i class="el-icon-warning-outline"
                                                                                       style="color:red;"></i> {{ item.nodeId }}</div>
                <div v-else>{{ item.nodeId }}</div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </span>
      <el-row>
        <!--        <el-button v-if="!resourceDetail && listOperations.some(operation => operation.name.includes('intelligentDistribution'))"-->
        <!--          type="primary"-->
        <!--          :disabled="Object.keys(sourceVals).length == 0"-->
        <!--          @click="intelligentDistribution">智能分配</el-button>-->
        <el-button v-if="isReset && listOperations.some(operation => operation.name.includes('release'))"
                   type="primary" @click="releaseResource">释放资源
        </el-button>
        <!--解析配置文件在释放资源之后显示出来-->
        <el-dropdown style="margin-left: 14px;" trigger="click"
                     v-if="ableEdit && !resourceDetail && listOperations.some(operation => operation.name.includes('configList'))">
          <el-button type="primary">
            解析配置文件<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(item, index) in moduleConfigs" :key="index">
              <!-- <el-button type="text" @click="uploadConfig(item)">{{item}}</el-button> -->
              <el-upload
                ref="upload"
                :on-success="handleSuccess"
                :on-error="handleError"
                :action="baseUrl3+'config/analysis/ins/config'"
                :show-file-list="false"
                name="filePart"
                :headers="{
                  Authorization: 'Bearer ' + token
                }"
                :data="{
                  configName: item.name,
                  configVersion: item.version,
                  instanceId: instanceId,
                  location: item.location,
                  moduleName: module,
                  moduleVersion: moduleVersion
                }"
              >
                <el-button type="text" size="mini">{{ item.name }} {{ item.version }}</el-button>
                <!-- <div style="display: flex;justify-content: space-between;">
                <span>{{item.name}}</span>
                <span>{{item.version}}</span>
                </div> -->
              </el-upload>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-select v-if="ableEdit" v-model="moduleType" placeholder="模块类型" @change="selectModule()"
                   style="margin-left: 14px;">
          <el-option
            v-for="item in moduleTypesByDevId"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>

        <el-select v-if="ableEdit" v-model="selectInstanceId" clearable placeholder="资源实例" @change="selectIns()"
                   style="margin-left: 14px;">
          <el-option
            v-for="item in instantceData"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>

        <h3>模块类型</h3>
        <module-type-ele :tags="moduleTypes" @chooseTag="getModuleResource"/>

        <el-form name="formData" :model="formData" label-width="236px" ref="rootRef">

          <el-form-item label="主备选择" v-if="mode == 'pair'"
                        prop="mode"
                        :rules="{required: true, message: '请选择主备'}">
            <el-select v-model="formData.mode" :disabled="!ableEdit">
              <el-option value="master" label="主"></el-option>
              <el-option value="slaver" label="备"></el-option>
            </el-select>
          </el-form-item>
          <propertity ref="proot" refName="proot"
                      :source="source"
                      :sourceVals="sourceVals"
                      :hasServiceHelper="hasServiceHelper"
                      :itemForm.sync="formData"
                      :ableEdit="ableEdit"
                      :resourceDetail="resourceDetail"
                      :occupyResourceData="occupyResourceData"/>

        </el-form>
      </el-row>
      <el-row style="text-align:center;" v-if="ableEdit">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancel(false)">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="inputView"
      width="25%"
      :modal-append-to-body="false">
      <el-form label-position="left" :model="form" ref="form" label-width="90px">
        <el-form-item prop="nodeId" label="指定业务ID:">
          <el-input v-model="form.nodeId" placeholder="请输入" style="width: 150px"></el-input>
        </el-form-item>
      </el-form>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button type="primary" @click="addNodeID()">绑 定</el-button>
        <el-button @click="inputView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <intelligent-distribution
      :sourceVals="sourceVals"
      :visible="showIntelligent"
      v-if="showIntelligent"
      @closeIntelligent="closeIntelligent"/>
  </div>
</template>
<script>
import {Loading} from "element-ui";
import ModuleTypeEle from './ModuleTypeEle.vue'
import Propertity from './common/Propertity'
import {mapMutations, mapState} from 'vuex';
import IntelligentDistribution from './PortIntelligentDistribution'

export default {
  name: "Source",
  props: {
    visible: {
      type: Boolean
    },
    deviceId: {
      type: [String, Number]
    },
    module: {
      type: String
    },
    moduleVersion: {
      type: String
    },
    // 是否是重新分配资源
    isReset: {
      type: Boolean,
      default: false
    },
    // 是否hasServiceHelper
    hasServiceHelper: {
      type: Boolean,
      default: false
    },
    // 实例ID
    instanceId: {
      type: [String, Number]
    },
    resourceId: {
      type: [String, Number]
    },
    // 是否已经分配资源成功，默认false。如果已分配资源，则回显资源信息
    registered: {
      type: Boolean
    },
    // 是否是查看资源详情
    resourceDetail: {
      type: Boolean
    },
    //是否是模块更新弹出
    oldDataId: {
      type: [String, Number]
    },
  },
  components: {ModuleTypeEle, Propertity, IntelligentDistribution},
  data() {
    return {
      point: false,
      remove: false,
      inputView: false,
      nodeName: "",
      form: {
        nodeId: ""
      },
      instanceIdList: [],
      moduleTypes: [], //模块类型
      source: [], //资源定义字段
      sourceUi: [], //页面上循环显示的资源定义
      sourceVals: [], //资源列表
      formData: {},
      isRoot: true,
      mode: null,
      ableEdit: true, //资源是否可分配。当重配资源进来，默认不可分配，点击释放资源后才可分配
      moduleConfigs: [],
      showIntelligent: false,
      moduleTypesByDevId: [],//设备id的模块类型
      moduleType: '',
      nodeId: 0,
      instantceData: [], //设备ID和模块类型查询所有的实例
      selectInstanceId: '',//选择的实例id
      occupyResourceData: null //实例的占用的资源信息
    }
  },
  computed: {
    ...mapState(['allref', 'listOperations']),
    token() {
      return localStorage.getItem('token')
    }
  },
  mounted() {
    // 请求设备资源
    if (!this.resourceDetail) {
      this.getResource()
    }

    // 模块类型
    if (this.module) {
      this.moduleTypes = [{
        name: this.module,
        selected: true
      }]
      this.getModuleResource(this.module)
      if (!this.resourceDetail) {
        this.getModuleConfigs(this.module, this.moduleVersion)
      }

    } else {
      this.getModules()
    }

    if (this.isReset) {
      this.ableEdit = false
    }
    if (this.resourceDetail) {
      this.ableEdit = false
    }

    if (this.ableEdit) {
      this.getModulesBydeviceId();
    }

    if (this.oldDataId) {
      this.selectInstanceId = this.oldDataId;
      this.getResouceByInsId();
    }

    this.getNodeId();
  },
  methods: {
    ...mapMutations(["clearEle", "clearRef", "clearPortmapVerified", "clearRangeVerified"]),
    getNodeId() {
      let data = {
        instanceId: this.instanceId,
        moduleType: this.module
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/findByInsId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data && data.nodeId) {
              _this.nodeId = data.nodeId
              _this.nodeName = data.nodeId
              _this.remove = true
            } else {
              _this.nodeName = "绑定业务ID"
              _this.remove = false
              _this.getInstanceIdList();
            }
          } else {
            _this.nodeName = "绑定业务ID"
            _this.remove = false
            _this.getInstanceIdList();
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    bindNodeId(command) {
      if (command == 'a') {
        this.$confirm('是否解除绑定?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.unbind()
          this.$message({
            type: 'success',
            message: '已解除绑定!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else if (command == 'b') {
        this.$confirm('直接新增业务ID 或 输入指定业务ID?', '提示', {
          confirmButtonText: '直接新增',
          cancelButtonText: '输入指定业务ID',
          type: 'warning'
        }).then(() => {
          this.addNodeID()
        }).catch(() => {
          this.form.nodeId = ""
          this.inputView = true
        });
      } else {
        this.$confirm('是否将该业务ID绑定到当前实例?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let data = {
            nodeId: command,
            instanceId: this.instanceId,
            moduleType: this.module
          }
          let _this = this;
          this.$axios.post(this.baseUrl3 + 'management3/node/bind', data)
            .then(({data: {msg, data, code}}) => {
              if (code == 20000) {
                _this.getNodeId();
              } else {
                _this.$message({showClose: true, message: msg, type: 'error'})
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      }
    },
    nodeClick() {
      if (!this.instanceIdList || this.instanceIdList.length == 0) {
        this.nodeIdView = true
        return
      }
    },
    getInstanceIdList() {
      var data = {
        moduleType: this.module
      };
      let _this = this;
      _this.instanceIdList = [];
      this.$axios.post(this.baseUrl3 + 'management3/node/findByModuleType', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.instanceIdList = data
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    addNodeID() {
      let data = {
        nodeId: parseInt(this.form.nodeId),
        instanceId: this.instanceId,
        moduleType: this.module
      }
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/node/insert', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.nodeIdView = false;
            _this.inputView = false;
            _this.getNodeId();
            _this.getInstanceIdList()
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    resetEles() {
      this.sourceUi = []
      this.source = []
    },
    uploadConfig(moduleType) {
      console.log(moduleType)
    },
    handleSuccess({code, msg, data}, file, fileList) {
      if (code == 20000) {
        const configData = JSON.parse(data.moduleResource.resource)
        const _this = this
        for (let key in configData) {
          _this.formData[key] = configData[key]
        }
      } else {
        this.$message.error("上传失败！原因：" + msg);
      }
    },
    handleError(err, file, fileList) {
      this.$message({showClose: true, message: "上传失败", type: "error"});
      console.log("error=" + err);
    },
    getModuleConfigs(moduleType, moduleVersion) {
      this.moduleConfigs = []
      this.$axios.get(this.baseUrl3 + 'config/get/configs/' + moduleType + '/' + moduleVersion)
        .then(({data: {code, data, msg}}) => {
          if (code != 20000) {
            console.error('获取模块配置文件列表失败')
          } else {
            this.moduleConfigs = data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getByInsId() {
      let param = {
        instanceId: this.instanceId,
        moduleType: this.module
      }
      this.$axios.post(this.baseUrl3 + "management3/node/findByInsId", param)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              this.nodeId = data.nodeId;
            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        });
    },
    // 获取模块类型
    getModules() {
      this.$axios.get(this.moduleUrl + "module/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.moduleTypes = data
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        });
    },
    // 通过设备id获取模块类型
    getModulesBydeviceId() {
      this.$axios.get(this.baseUrl3 + "instance/findModuleTypeByDevId/" + this.deviceId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.moduleTypesByDevId = data;
            this.moduleType = this.module;
            this.getInsForRegister();
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        });
    },
    selectModule() {
      if (this.ableEdit) {
        this.getInsForRegister();
      }
    },
    selectIns() {
      if (this.ableEdit || this.oldDataId) {
        this.getResouceByInsId();
      }
    },
    // 返回指定实例占用资源
    getResouceByInsId() {
      if (this.selectInstanceId) {
        this.$axios.get(this.baseUrl3 + "instance/getResourceByInsId/" + this.selectInstanceId)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.occupyResourceData = data;
              this.nodeId = data.nodeId;
              if (data.nodeId == 0 || !data.nodeId) {
                this.nodeName = "绑定业务ID";
              }
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          });
      } else {
        this.occupyResourceData = {};
      }
    },
    // 根据设备ID与模块类型查询已分配资源的实例
    getInsForRegister() {
      this.$axios.get(this.baseUrl3 + "instance/findInsForRegister/" + this.moduleType + "/" + this.deviceId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.instantceData = data;
            // this.selectInstanceId = '';
            // this.occupyResourceData = {};
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        });
    },
    // 获取设备资源(主要是ip和端口)
    // getResource(){
    //   if(!this.deviceId){
    //     return
    //   }
    //   this.$axios.get(this.baseUrl3 + 'device/getResourceById/' + this.deviceId)
    //   .then(({data:{code, data, msg}}) => {
    //     if(code != 20000){
    //       this.$message.error('获取资源定义失败！' + msg)
    //     }else{
    //       this.sourceVals = {
    //         ip: data.ip,
    //         wanip: data.wanIp
    //       }
    //
    //     }
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
    // },
    getResource() {
      if (!this.deviceId) {
        return
      }
      let param = {
        id: this.deviceId
      }
      this.$axios.post(this.baseUrl3 + 'management3/device/getResourceById', param)
        .then(({data: {code, data, msg}}) => {
          if (code != 20000) {
            this.$message.error('获取资源定义失败！' + msg)
          } else {
            this.sourceVals = data
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取模块资源
    getModuleResource(moduleType) {
      this.resetEles()
      // 资源定义
      this.getDefinition(moduleType)
    },
    getDefinition(moduleType) {
      this.source = []
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.moduleResourceUrl + 'module/resource/get/definition/' + moduleType)
        .then(({data: {code, data, msg}}) => {
          if (code != 20000) {
            this.$message.error('获取资源定义失败！' + msg)
          } else {
            this.source = data.properties ? data.properties.propertyList : []
            this.mode = data.mode
            if (this.source.length > 0) {
              // this.renderRules()
            }
            // this.findResource()
            // 重新分配资源 或 查看资源分配时，才需要查询实例已分配的资源
            if (this.isReset || this.resourceDetail || this.registered) {
              this.findResource()
            }
          }
          loading.close();
        })
        .catch(err => {
          loading.close();
          console.log(err)
        })
    },
    intelligentDistribution() {
      this.showIntelligent = true
    },
    closeIntelligent(val) {
      this.showIntelligent = false
      this.autoAssign(val ? val : 0)
    },
    autoAssign(port) {
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios.get(this.baseUrl3 + "instance/intelligentDistribution/" + this.instanceId + "/" + port)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            const configData = JSON.parse(data)
            const _this = this
            for (let key in configData) {
              _this.formData[key] = configData[key]
            }
            this.$refs.proot.displayResource()
          } else {
            this.$message({showClose: true, message: msg, type: "error"})
          }
          loading.close()
        }).catch(err => {
        this.$message.error('请求失败')
        console.log(err)
        loading.close()
      });
    },
    cancel(val) {
      let model = val ? val : false
      this.$emit('sourceCallback', model)
      this.clearEle()
      this.clearRef()
      this.clearPortmapVerified()
      this.clearRangeVerified()
    },
    getAllRefs(obj, arr) {
      let _this = this

      if (Object.keys(obj).length == 0) {
        return
      }

      for (let key in obj) {
        const item = obj[key]
        if (Object.prototype.toString.call(item) == '[object Object]') {
          let pro = new Promise((resolve, reject) => {
            item.validate((valid) => {
              if (valid) {
                resolve()
              } else {
                reject()
              }
            })
          })
          arr.push(pro)
        } else if (Object.prototype.toString.call(item) == '[object Array]') {
          // item[0]
          if (item.length > 0) {
            // if(!item[0].$refs.occupyResourceData && item[0].occupyResourceData){
            //   item[0].$refs.occupyResourceData = item[0].occupyResourceData
            // }

            _this.getAllRefs(item[0].$refs, arr)
          }

        }
      }
      return arr
    },
    save() {
      if (!this.nodeId) {
        // this.point = true
        this.$message.warning('当前实例未绑定业务ID！')
        return;
      }
      // if(Object.keys(this.formData).length == 0){
      //   this.$message.warning('请至少分配一个资源')
      //   return
      // }
      this.clearEle()
      this.clearRangeVerified()

      const ref = this.$refs.proot.$refs
      let arr = []
      let allRef = this.getAllRefs(ref, arr)
      let _this = this

      if (this.mode == 'pair') {
        let rootRefItem = new Promise((resolve, reject) => {
          _this.$refs.rootRef.validate((valid) => {
            if (valid) {
              resolve()
            } else {
              reject()
            }
          })
        })
        allRef.unshift(rootRefItem)
      }
      Promise.all(allRef).then(() => {
        console.log('验证通过')
        let _param = this.formData;
        _param.NODE_ID = _this.nodeId
        this.cancel(JSON.stringify(_param))
      }).catch(() => {
        console.log('验证不通过')
        setTimeout(() => {
          var isError = document.getElementsByClassName("is-error");
          isError[0].querySelector('input').focus();
        }, 100);
      })

    },

    // 释放资源
    // releaseResource(){
    //   this.$emit('releaseResource')
    // },
    releaseRequest() {
      this.$axios.get(this.baseUrl3 + "instance/release/resource/" + this.instanceId)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.$message.success('操作成功')
            this.ableEdit = true
            // 资源释放成功后需要重新获取下资源
            this.getResource()
            this.clearEle()
            this.clearRangeVerified()
            this.$emit('sourceCallback', false)
          } else {
            this.$message({showClose: true, message: msg, type: "error"})
          }
        }).catch(err => {
        this.$message.error('请求失败')
        console.log(err)
      });
    },
    // 释放资源
    releaseResource() {
      let _this = this
      this.$confirm('您确定要释放资源吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.releaseRequest()
      }).catch(() => {
      });
    },

    // 获取实例的资源
    findResource() {
      let _this = this;
      this.$axios.get(this.baseUrl3 + 'instance/findById/resource/' + this.resourceId)
        .then(({data: {msg, data, code}}) => {
          if (data.content) {
            let instanceResource = JSON.parse(data.content)

            for (let key in instanceResource) {
              if (!_this.formData.hasOwnProperty(key)) {
                this.$set(_this.formData, key, instanceResource[key])
              } else {
                _this.formData[key] = instanceResource[key]
              }

            }

            this.$refs.proot.displayResource()
            //_this.formData = instanceResource

          } else {
            console.log('未获取到该实例的资源')
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

  },
  created() {
  }
};
</script>

<style scoped>
.tips {
  font-size: 12px;
  color: #b3b1b1;
  margin-left: 4px;
  display: inline-block;
}

</style>
